import { shareUrl, wxShareLogo } from "./url";
const shareTitle = "你的好友正在为喜欢的南方号打榜拉票中，快来助力！";
const shareDesc = "你喜欢的南方号在人气榜上排名第几？点开看看";
// const shareIcon = 'https://static.nfnews.com/app/nanfang_logo.png';
const shareIcon = wxShareLogo;

export { shareUrl, shareTitle, shareDesc, shareIcon };



// WEBPACK FOOTER //
// ./src/js/shareInfo.js